<template>
  <div class="container">
    <div id="page1-div" ref="document" class="container interline">
      <div
        class="col-12 container border page-container"
      >
        <div class="col-12 border-bottom border-dark text-center pt-5">
          <span class="ft10Black">
            CARÁTULA DE CONTRATO DE APERTURA DE CRÉDITO SIMPLE CON GARANTÍA
            PRENDARIA SIN TRANSMISIÓN DE LA POSESIÓN
          </span>
        </div>
        <div class="col-12 m-1">
          <span class="ft11">
            El cuadro informativo siguiente, establece: (i) las características
            aplicables a la operación relacionada con el contrato de apertura de
            crédito simple con garantía prendaria sin transmisión de la posesión
            que celebran
            <span class="ft10Black"> GPI AUTO COMERCIAL SAPI DE C.V.</span>
            como <span class="ft10Black">ACREDITANTE</span>, y
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black ">
              {{ data.nombre_cliente }},
            </span> como ACREDITADO, en
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }},
            </span>
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.estado_cliente }}</span
            >, el día
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black"
              >{{ data.fecha_contrato }}</span
            >
            y, (ii) la información que determina el contrato.
          </span>
        </div>
        <!-- tabla -->
        <div class="col-12 border border-dark  row m-0 p-0">
          <!-- row 1 -->
          <div class="col-2 border-right border-dark text-center m-0 p-0">
            <span class="ft11Black">
              CAT Costo Anual Total
            </span>
          </div>
          <div class="col-2 border-right border-dark text-center m-0 p-0">
            <span class="ft11Black">
              TASA DE INTERES
            </span>
          </div>
          <div class="col-2 border-right border-dark text-center m-0 p-0">
            <span class="ft11Black">
              MONTO DEL CRÉDITO
            </span>
          </div>
          <div class="col-2 border-right border-dark text-center m-0 p-0">
            <span class="ft11Black">
              MONTO TOTAL A PAGAR
            </span>
          </div>
          <div class="col-4 text-center m-0 p-0">
            <span class="ft11Black">
              COMISIONES Montos Y Cláusulas
            </span>
          </div>
          <!-- row 2 -->
          <div
            class="col-2 border-right border-top border-dark text-center auto"
          >
            <span class="ft11">
              Para fines informativos y de comparación
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.cat_anual }} Sin I.V.A.
              </span>
            </span>
          </div>
          <div
            class="col-2 border-right border-top border-dark text-center auto"
          >
            <span class="ft11">
              <span class="ft11Black">Ordinario:</span><br />
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.tasa_ordinaria }}%</span
              >
              Fijo más IVA
              <br />
              <span class="ft11Black">Por Mora:</span><br />
              <span v-bind:class="{ marca: data.showMarca }"
                >{{ data.moratorio }}%</span
              >
              Fijo por mes
            </span>
          </div>
          <div
            class="col-2 border-right border-top border-dark text-center m-0 p-0"
          >
            <span class="ft11">
              <span v-bind:class="{ marca: data.showMarca }">
                ${{ data.monto_a_finaciar }} pesos, M.N.
              </span>
            </span>
          </div>
          <div
            class="col-2 border-right border-top border-dark text-center auto"
          >
            <span class="ft11">
              Estimado según el contrato <br />
              <span v-bind:class="{ marca: data.showMarca }">
                ${{ data.monto_total }} pesos, M.N.
              </span>
            </span>
          </div>
          <div class="col-4 border-top border-dark auto">
            <span class="ft11">
              <span class="ft11Black">Por apertura:</span> 2.58% más I.V.A.
              Cláusula Décima Primera. <br /><span class="ft11Black"
                >Por Gastos de Cobranza:</span
              >
              8% más I.V.A. Cláusula Décima Primera. <br /><span
                class="ft11Black"
                >Por Pago Anticipado:</span
              >
              25% Cláusula Décima Primera. <br /><span
                class="ft11Black"
                >Por Gastos de Administración de Saldos:</span
              >
              ${{SEGURODEUDOR}} pesos M.N. incluye I.V.A. Cláusula Décima Primera.
              <br /><span class="ft11Black">Cargo por Servicio GPS:</span>
              ${{GPS}} pesos M.N. incluye I.V.A. Cláusula Décima Primera.
            </span>
          </div>
          <!-- row 3 -->
          <div class="col-12 border-top border-dark px-1">
            <span class="ft11">
              <span class="ft11Black">
                Metodología de cálculo del interés:
              </span>
              Se calcula multiplicando el monto del crédito por la tasa de
              interés mensual y por el plazo del crédito. (Sin que incluya el
              Seguro, el cual será calculado conforme al plazo de la póliza.)
            </span>
          </div>
          <!-- row 4 -->
          <div class="col-12 border-top border-dark px-1">
            <span class="ft11">
              <span class="ft11Black">
                Plazo del crédito
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.plazo }} meses
                </span>
              </span>
              <br />
              <span class="ft11Black">Sus pagos serán como sigue:</span>
            </span>
          </div>
          <!-- row 7 -->
          <div
            class="col-4 border-right border-top
            border-dark text-center auto"
          >
            <span class="ft11">
              <u class="ft12Black">Número de parcialidades</u><br />
              <span class="ft11Black">
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.plazo }}
                </span>
              </span>
              <br />
            </span>
          </div>
          <div
            class="col-4 border-right border-top border-dark text-center auto"
          >
            <span class="ft11">
              <u class="ft12Black">Monto de las parcialidades</u>
              <br />
              Incluye IVA, por lo que pueden existir pequeñas variaciones en
              cada pago
              <span v-bind:class="{ marca: data.showMarca }">
                ${{ data.mensualidad }} {{ data.mensualidad_letra }}
              </span>
            </span>
          </div>
          <div class="col-4 border-top border-dark text-center auto">
            <span class="ft11">
              <u class="ft12Black">
                Cuándo se realizan los pagos de las parcialidades </u
              ><br />
              Periodicidad: Mensual <br />
              Iniciando el:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.fecha_primer_pago }}
              </span>
            </span>
          </div>
          <!-- row 8 -->
          <div class="col-12 border-top border-dark px-1">
            <span class="ft11">
              "Cuide su capacidad de pago, generalmente sus pagos por créditos
              no debe de exceder en conjunto del 35% de sus ingresos
              periódicos." "Contratar créditos por arriba de su capacidad de
              pago puede afectar su historial crediticio." "El obligado
              solidario responderá como obligado principal frente a la Entidad
              Comercial."
            </span>
          </div>
          <!-- row 9 -->
          <div class="col-12 border-top border-dark px-1">
            <span class="ft11">
              <span class="ft11Black">Autorización:</span> Los datos personales
              pueden utilizarse para mercadeo:
              <div class="col-12 text-center m-0 p-0"><br />O Si O No</div>
            </span>
          </div>
          <!-- row 10 -->
          <div class="col-12 border-top border-dark auto">
            <span class="ft11">
              <div class="col-12 text-center m-0 p-0">
                <br /><span class="ft11Black">Garantía</span>
              </div>
              Para garantizar el pago del Crédito, el Acreditado constituye
              Prenda sin transmisión de Posesión a favor del Acreditante y sobre
              el Bien que se describe a continuación:
            </span>
          </div>
          <!-- row 11 -->
          <div
            class="col-4 border-right border-top border-dark text-center auto"
          >
            <span class="ft12Black">Garantía</span>
          </div>
          <div
            class="col-4 border-right border-top border-dark text-center auto"
          >
            <span class="ft12Black">
              Descripción
            </span>
          </div>
          <div class="col-4 border-top border-dark text-center auto">
            <span class="ft12Black">
              Referencias
            </span>
          </div>
          <!-- row 12 -->
          <div
            class="col-4 border-right border-top border-dark text-center auto"
          >
            <span class="ft11">Automóvil</span>
          </div>
          <div class="col-4 border-right border-top border-dark auto">
            <span class="ft11">
              Marca:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.marca_vehiculo }}
              </span>
              <br />
              Modelo:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.modelo_vehiculo }}
              </span>
              <br />
              Año:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.año_vehiculo }}
              </span>
              <br />
            </span>
          </div>
          <div class="col-4 border-top border-dark auto">
            <span class="ft11">
              No. Serie:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.numero_serie_vehiculo }} </span
              >
              <br />
              No. Motor:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.numero_motor_vehiculo }} </span
              >
            </span>
          </div>
          <!-- row 13 -->
          <div class="col-12 border-top border-dark text-center auto">
            <span class="ft12Black">Seguros</span>
          </div>
          <!-- row 14 -->
          <div
            class="col-4 border-right border-top border-dark text-center auto"
          >
            <span class="ft11">
              <span class="ft12Black">Tipo de cobertura Anual: </span><br />
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.seguro_covertura }}
              </span>
              Cubre el primer año del crédito
            </span>
          </div>
          <div class="col-4 border-right border-top border-dark auto">
            <span class="ft11Black">
              Aseguradora:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.seguro_nombre }}
              </span>
            </span>
          </div>
          <div class="col-4 border-top border-dark auto">
            <span class="ft12Black">
              Cláusula Octava
            </span>
          </div>
          <!-- row 15 -->
          <div class="col-12 border-top border-dark auto">
            <span class="ft11">
              <span class="ft12Black">
                Dudas, aclaraciones y reclamaciones:
              </span>
              <div class="col-12 auto">
                <span class="ft12Black"> • </span>
                Para cualquier duda, aclaración o reclamación, favor de
                dirigirse a: Domicilio: AV. LAS ROSAS 2991, COL. CHAPALITA,
                GUADALAJARA, JALISCO, C.P. 44510 Teléfono: (33) 1078-2828/29,
                correo electrónico: atencionclientes@gpiautocomercial.com.mx
                Responsable: ALONDRA DELGADO Página de Internet: credimovil.mx.
              </div>
              <div class="col-12 auto">
                <span class="ft12Black"> • </span>
                O en su caso a: Procuraduría Federal del Consumidor (PROFECO):
                Teléfonos: 5625-6700 ó 01800-468-8722, Página de Internet:
                www.profeco.gob.mx.
              </div>
            </span>
          </div>
          <!-- row 16
          <div class="col-12 border-top border-dark auto">
            <span class="ft12">
              <span class="ft12Black">ESTADO DE CUENTA:</span><br />
              <span class="ft11Black">
                Con periodicidad:
              </span>
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.periodicidad }}
              </span>
              <br />
              <span class="ft11Black">
                Consulta vía internet:
              </span>
              clave de acceso que se proporcionará en el instrumento de pagos
            </span>
          </div> -->
        </div>
        <!-- row 17 -->
        <div class="col-12 auto">
          <span class="ft12">
            En conformidad con la Carátula y, toda vez que forma parte del
            Contrato, el acreditado la firma a su entera satisfacción en e l
            lugar y fecha arriba indicados.
          </span>
        </div>
        <!-- row 17 -->
        <div class="col-12 auto">
          <div class="col-12 text-center pt-2 pb-4">
            <span class="ft13">
              ATENTAMENTE
            </span>
          </div>
        </div>
        <!-- row 18 -->
        <div class="col-12 row auto">
          <div class="col-3 text-center pt-2 auto"></div>
          <div class="col-6 text-center border-top border-dark auto pt-2 auto">
            <span v-bind:class="{ marca: data.showMarca }" class="ft13Black">
              {{data.nombre_cliente}}
            </span>
          </div>
          <div class="col-3 text-center pt-2 auto"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import environment from "../../../environments/Environment";
export default {
  name: "Caratura1",
  data() {
    return {
      SEGURODEUDOR: environment.SEGURODEUDOR,
      GPS: environment.GPS
    };
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/Caratura1/Caratura1.vue